<template>
    <div class="flex h-full w-full items-center justify-center flex-col">
        <div v-if="checking">
            {{ $t('checking_browser_support') }}
        </div>

        <div v-if="canInstall">
            <div class="p-10 text-purple-100 font-light text-center">
                <h2 class="text-2xl">
                    {{ $t('you_want_to_install_this_app_on_your_device') }}
                </h2>
            </div>

            <div class="w-full text-center">
                <icon icon="mobile-alt" size="8x"></icon>
            </div>

            <div class="w-full p-20">
                <button class="btn btn-orange block" @click="install()">{{ $t('install_now') }}</button>

                <button class="btn block mt-3" @click="next()">
                    {{ $t('dont_install') }} <br>
                    {{ $t('use_in_my_browser') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            if(!window.installabe) {
                setTimeout(() => {
                    if(!window.installabe) {
                        this.next();
                    } else {
                        this.canInstall = true;
                        this.checking = false;
                    }
                }, 5000);
            } else {
                if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
                    this.next();
                } else {
                    this.canInstall = true;
                    this.checking = false;
                }
            }

            window.addEventListener('appinstalled', (evt) => {
                console.log('INSTALL: Success', evt);
            });
        },

        data() {
            return {
                checking: true,
                canInstall: false
            }
        },

        methods: {
            install() {
                window.installPrompt.prompt();

                window.installPrompt.userChoice
                    .then((r) => {
                        if(r.outcome === 'accepted') {
                            console.log('accpeted');
                        }
                    })
            },

            next() {
                this.$router.push({
                    name: 'Dashboard',
                    replace: true
                });
            }
        }
    }
</script>